import React from 'react'
import Slider from 'react-slick/lib'
import PropTypes, { string } from 'prop-types'
import './index.css'
import CategoriesCarouselBanner from '../CategoriesCarouselBanner'

const CategoriesCarouselAbTesting = ({ data, isMobile, cardContainer }) => {
  const idComponent = data.experimentId.length > 0 ? data.experimentId : data.categoryName
  const settingsCategories = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 6,
    arrows: false,
    responsive: [
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          infinite: false,
        },
      },
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  const renderCategoriesImages = () =>
    data &&
    data.categories.map((ele, index) => {
      const { categoryName, name, internal, image, link } = ele

      return (
        <div key={index}>
          <CategoriesCarouselBanner
            categoryName={categoryName}
            name={name}
            image={image}
            index={index}
            internal={internal}
            link={link}
            title={data.title}
          />
        </div>
      )
    })

  const getFixedSliderNumberSettings = () => {
    const slidesLength = data.categories.length
    const fixedSettingsCategories = {
      ...settingsCategories,
      slidesToShow: Math.min(settingsCategories.slidesToShow, slidesLength),
      slidesToScroll: Math.min(settingsCategories.slidesToScroll, slidesLength),
    }

    fixedSettingsCategories.responsive = settingsCategories.responsive.map((element) => ({
      ...element,
      settings: {
        ...element.settings,
        slidesToShow: Math.min(element.settings.slidesToShow, slidesLength),
        slidesToScroll: Math.min(element.settings.slidesToScroll, slidesLength),
      },
    }))

    return fixedSettingsCategories
  }

  const showCategoriesImages = (isMobile, cardContainer) => {
    if (isMobile) {
      const cardContainerStyles = {
        position: 'unset',
        marginLeft: '-15px',
        marginRight: '-15px',
        width: 'auto',
      }

      return (
        <div className="categories-mobile-slide-container-se">
          <div className="categories-mobile-slide-se" style={cardContainer ? cardContainerStyles : {}}>
            <div className="d-flex pb-10 categories-mobile-slide-se-overflow">{renderCategoriesImages()}</div>
          </div>
        </div>
      )
    }

    return (
      <div className="text-center">
        <Slider {...getFixedSliderNumberSettings()}>{renderCategoriesImages()}</Slider>
      </div>
    )
  }

  const renderHeader = (isMobile) => {
    if (isMobile) {
      return (
        <div className="d-flex mt-10 mb-10">
          <h1 className="categories-carousel-header-se" data-testid="categories-carousel-header">
            {data.title}
          </h1>
        </div>
      )
    }
    return (
      <div className="d-flex mb-20">
        <h1 className="categories-carousel-header-se" data-testid="categories-carousel-header">
          {data.title}
        </h1>
      </div>
    )
  }

  return (
    <div id={idComponent}>
      {renderHeader(isMobile)}
      {showCategoriesImages(isMobile, cardContainer)}
    </div>
  )
}

CategoriesCarouselAbTesting.defaultProps = {
  data: {},
  categoriesImagesAllSizes: [],
  isMobile: true,
  headerTitle: '¡Compra online por categorías!',
  cardContainer: false,
  category: '',
  enable: true,
  enableForTest: true,
  experimentId: '',
  categoryName: '',
}

CategoriesCarouselAbTesting.propTypes = {
  data: PropTypes.object,
  categoriesImagesAllSizes: PropTypes.array,
  isMobile: PropTypes.bool,
  headerTitle: PropTypes.string,
  cardContainer: PropTypes.bool,
  category: PropTypes.string,
  enable: PropTypes.bool,
  enableForTest: PropTypes.bool,
  experimentId: string,
  categoryName: string,
}

export default CategoriesCarouselAbTesting
